<template>
  <section v-on:click="sectionClicked" class="features">
    <div ref="gHelper"></div>
    <div class="cnt">
      <div class="sectionHeader" v-if="section.title[lang] || section.descriptions[lang]">
        <h4 class="sectionTitle" v-if="section.title[lang]">{{section.title[lang]}}</h4>
        <p class="sectionDesc" v-if="section.descriptions[lang]">{{section.descriptions[lang]}}</p>
      </div>
    </div>
    <div class="galleryCnt">
      <div class="gallerySc" :style="{'margin-left': `${gOffset}px`}">
        <div class="galleryWrapper gallery1">
          <div class="galleryItem" :class="`s${i}`"
            v-for="(item, i) in section.items.slice(0, 6)" :key="`g1${i}`">
            <div class="galleryImg" v-if="item && item.imageSm"
              :style="{'background-image': `url(${item.imageSm})`}"></div>
            <div class="galleryImg noImg" v-else></div>
          </div>
        </div>
      </div>
      <div class="gallerySc" :style="{'margin-left': `${-gOffset}px`}">
        <div class="galleryWrapper gallery2">
          <div class="galleryItem" :class="`s${i + 6}`"
            v-for="(item, i) in section.items.slice(6)" :key="`g2${i}`">
            <div class="galleryImg" v-if="item && item.imageSm"
              :style="{'background-image': `url(${item.imageSm})`}"></div>
            <div class="galleryImg noImg" v-else></div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'home',
  props: ['section'],
  components: {},
  data() {
    return {
      gOffset: 40,

      /**
       * Language
       *
       */
      langCode: 'id-id',
      lang: 'id',
    };
  },
  methods: {
    doNothing() {},
    sectionClicked() {},
    scrolled() {
      const factor = (window.screen.width >= 769) ? 0.4 : 0.14;
      this.gOffset = -(window.scrollY - (this.$refs.gHelper.offsetTop - 600)) * factor;
      if (this.gOffset > 40) this.gOffset = 40;
    },
  },
  created() { document.addEventListener('scroll', this.scrolled); },
  destroyed() { document.removeEventListener('scroll', this.scrolled); },
  mounted() {
    this.langCode = this.$route.params.lang;
    this.lang = this.langCode === 'id-id' ? 'id' : 'en';
  },
};
</script>

<style scoped lang="scss">
.galleryCnt{
  overflow: hidden;
  @media (max-width: 680px) {
    padding-bottom: 20px;
  }
}
.galleryWrapper{
  background-size: auto 100%;
  background-repeat: no-repeat;
  display: flex;
  width: 144vw;
  padding: 15px 0;
  @media (max-width: 1040px) {
    padding: 10px 0;
  }
  @media (max-width: 740px) {
    padding: 5px 0;
  }
  .galleryItem{
    background-color: #eee;
    width: calc(24vw - 30px);
    margin-right: 30px;
    border-radius: 5px;
    position: relative;
    overflow: hidden;
    cursor: pointer;
    transition: all .3s ease;
    height: 240px;
    @media (max-width: 1480px) {
      height: 200px;
    }
    @media (max-width: 1280px) {
      height: 160px;
    }
    @media (max-width: 1040px) {
      height: 140px;
      width: calc(24vw - 20px);
      margin-right: 20px;
    }
    @media (max-width: 740px) {
      height: 120px;
      width: calc(24vw - 10px);
      margin-right: 10px;
    }
    @media (max-width: 540px) {
      width: 100%;
      height: 94px;
    }
    &.s4, &.s5, &.s10, &.s11{
      @media (max-width: 540px) {
        display: none;
      }
    }
    &:hover{
      transform: scale(1.04);
    }
    .galleryImg{
      background-position: center;
      background-size: cover;
      position: absolute;
      left: 0; top: 0; right: 0; bottom: 0;
    }
  }
  &.gallery1{
  }
  &.gallery2{
    margin-left: calc(-44vw + 40px);
  }
}
</style>
